import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/database';
import _ from 'lodash'
import format from 'date-fns/format'
import setYear from 'date-fns/set_year'
import addMonths from 'date-fns/add_months';
import lastDayOfMonth from 'date-fns/last_day_of_month';
import differenceInCalendarDays from 'date-fns/difference_in_calendar_days'
import differenceInCalendarMonths from 'date-fns/difference_in_calendar_months'
import differenceInCalendarYears from 'date-fns/difference_in_calendar_years'
import {globalfunc} from '../globalfunc.js'
import { getUsersByCompany } from './cacheService'
export default {
    namespaced: true,
    state: {
      managers:[],
      managersall:[],
      teamall:[],
      inputSearch: '',
      page:1,
      // btNext:false,
      // btprevious:false,
      size_page:10,
      sortfield:'value',
      sortorder:'asc',
      results: 0,
      sortBy: 'firstname',
      subManagerByKey: [],
      membersByKey: [],
      bossByKey: [],
      teamByKey: [],
      loadingManagersTable: true,
    },
    mutations: {
      setManager(state:any, result:any) {
        state.managers = result
      },
      setManagerall(state:any, result:any) {
        state.managersall = result
      },
      setSubManager(state:any, result:any) {
        state.subManagerByKey = result
      },
      setTeamall(state:any, result:any) {
        state.teamall = result
      },
      setinputSearch(state:any,value:any) {
        state.inputSearch = value.keyword
      },
      setPage(state:any,result:any) {
        state.page = result
      },
      // setbtNext(state:any,result:any) {
      //   state.btNext = result
      // },
      // setbtPrevious(state:any,result:any) {
      //   state.btprevious = result
      // },
      setSortfield(state:any,result:any) {
        state.sortfield = result
      },
      setSortorder(state:any,result:any) {
        state.sortorder = result
      },
      setResults(state:any, result:any) {
        state.results = result
      },
      setMemberKey(state:any, result:any) {
        state.membersByKey = result
      },
      setBossKey(state:any, result:any) {
        state.bossByKey = result
      },
      setTeamKey(state:any, result:any) {
        state.teamByKey = result
      },
      setLoadingManagersTable(state:any, result:any) {
        state.loadingManagersTable = result
      },
    },
    actions: {
      async getMemberManager({commit,dispatch,state}:any, user:any){
        commit('setLoadingManagersTable',true)
        commit('setManager',[])
        let dateNow = new Date()
        let count = 0
        let thisYear = parseInt(format(dateNow, 'YYYY'))
        const users:Array<any> = [];
        const memberKey:Array<any> = [];
        const userSub:Array<any> = [];
        const allBoss:Array<any> = [];
        const team = (await firebase.database().ref('team').orderByChild("company").equalTo(user.company).once('value')).val()
        let allUser = await getUsersByCompany(user.company)
        const company = (await firebase.database().ref(`/company/${user.company}`).once('value')).val()
        try {
          const _usersByCompany = await getUsersByCompany(`${user.company}`)
          const usersManager:Array<any> = [];
          Object.entries(_usersByCompany).forEach(([childKey, childData]:any) => {
            const u = childData
              u.key = childKey

              u.value = childData.firstname + " " + childData.lastname

              let k_boss = childData.boss.replace(/\./g, "||")
              if(k_boss && allUser[k_boss] != undefined){
                u.boss_name = allUser[k_boss]["firstname"] + " " + allUser[k_boss]["lastname"]
                u.boss_firstname = allUser[k_boss]["firstname"]
                u.boss_lastname = allUser[k_boss]["lastname"]
                u.boss_shortname = allUser[k_boss]["firstname"] + " " + allUser[k_boss]["lastname"].charAt(0)
                if(allUser[k_boss]['profilepic_small']){
                  u.boss_pic = allUser[k_boss]['profilepic_small'];
                }else if (allUser[k_boss]['profilepic_crop']){
                  u.boss_pic = allUser[k_boss]['profilepic_crop'];
                }else if (allUser[k_boss]['profilepic']){
                  u.boss_pic = allUser[k_boss]['profilepic'];
                }else {
                  u.boss_pic = "";
                }
              }
              if(u.team) u.team_name = (team[u.team]!=undefined)?team[u.team]["name"]:''
              if(u.team) u.team_color = (team[u.team]!=undefined)?team[u.team]["color"]:''
              if(u.profilepic_small){
                u.pic = u.profilepic_small;
              }else if (u.profilepic_crop){
                u.pic = u.profilepic_crop;
              }else if (u.profilepic){
                u.pic = u.profilepic;
              }else {
                u.pic = "";
              }

              if(u.profilepic) {
                u.large_pic = u.profilepic
              }else if(u.profilepic_crop) {
                u.large_pic = u.profilepic_crop
              }else if(u.profilepic_small){
                u.large_pic = u.profilepic_small
              }else {
                u.large_pic = ""
              }

              if(company.medal && u.medal){
                _.forEach(u.medal, (value,key)=> {
                  u.medal[key] = company.medal[key]
                });
              }
              if(u.tutorial && u.tutorial == 'Y'){
                let dayActive = differenceInCalendarDays(dateNow, u.updated)
                if(dayActive > 30){
                  u.status = 'inactive'
                  u.to_now = format(u.updated,'MMM D, YYYY')
                }else{
                  u.status = 'active'
                  u.to_now = globalfunc.timeSince(u.updated)
                }
              }else if(u.invited){
                u.status = 'invited'
                u.to_now = globalfunc.timeSince(u.updated)
              }else{
                u.status = 'new'
              }
              if(u.joined_tooltips === undefined){
                u.joined_tooltips = new Array()
              }
              if(u.workdate){
                u.joined = format(u.workdate,'MMMM D, YYYY')
                let arrJoined:Array<any> = [];
                arrJoined['year'] = differenceInCalendarYears(dateNow, u.workdate)
                let month = differenceInCalendarMonths(dateNow, setYear(u.workdate,thisYear))
                if(month < 0){
                  arrJoined['month'] = month + 12
                  arrJoined['year'] = (arrJoined['year'] > 0) ? arrJoined['year'] - 1 : 0
                }else{
                  arrJoined['month'] = month
                }
                let day = parseInt(format(dateNow,'DD')) - parseInt(format(u.workdate,'DD'))
                if(day < 0){
                  arrJoined['day'] = day + parseInt(format(lastDayOfMonth(addMonths(dateNow, -1)),'DD'));
                  if(arrJoined['month'] > 0){
                    arrJoined['month'] = arrJoined['month'] - 1
                  }else{
                    arrJoined['month'] = 12
                    arrJoined['year'] = (arrJoined['year'] > 0) ? arrJoined['year'] - 1 : 0
                  }
                }else{
                  arrJoined['day'] = day
                }
                u.joined_tooltips.push(arrJoined)
              }
              if(u.boss){
                allBoss[k_boss] = u.boss
                if(userSub[u.boss] === undefined){
                  userSub[u.boss] = new Array()
                }
                userSub[u.boss].push(u)
              }
              memberKey[u.key] = u
              users.push(u)
          });
          Object.entries(allBoss).forEach(([key, item]) =>{
            let _item = memberKey[key]
            if(_item){
              _item.sub_total = (userSub[_item.email])?userSub[_item.email].length:0
              usersManager.push(_item)
            }
          });
          let _usersCheck:Array<any> = [];
          _usersCheck = _.sortBy(users, [function(o:any) { return o.workdate; }])
          let orderJoin = 1
          _.forEach(_usersCheck, (item,key)=> {
            if(item.workdate){
              _usersCheck[key].order_join = orderJoin
              orderJoin++
            }
          });
          _.forEach(usersManager, (item,key)=> {
            let managerExist = _.filter(_usersCheck, {
              email: item.email
            });
            if(item.workdate && managerExist.length > 0){
              usersManager[key].order_join = managerExist[0].order_join
            }
          });
          var _users = _.sortBy(usersManager, [function(o:any) { return o.firstname; }])
          commit('setBossKey', allBoss)
          commit('setTeamKey', team)
          commit('setMemberKey', memberKey)
          commit('setSubManager',userSub)
          commit('setResults',usersManager.length)
          commit('setManager', _.sortBy(_users.slice(0, state.size_page), [function(o:any) { return o.firstname; }]))
          commit('setManagerall', _.sortBy(usersManager, [function(o:any) { return o.firstname; }]))
          commit('setLoadingManagersTable',false)
          if(state.inputSearch){
            dispatch('searchMembers',state.inputSearch)
          }
        } catch(error) {
          console.log(error)
        }
      },
      async getTeamAll({commit,dispatch,state}:any, user:any){
        const team = (await firebase.database().ref('team').orderByChild("company").equalTo(user.company).once('value')).val()
        firebase.database().ref('team').orderByChild("company").equalTo(`${user.company}`).once('value', snapshot => {
          const teamData:Array<any> = [];
          snapshot.forEach((arrData):any => {
            const u = arrData.val()
            u.key = arrData.key
            u.value = arrData.val().name
            teamData.push(u)
            
          });
          commit('setTeamall', _.sortBy(teamData, [function(o:any) { return o.name; }]))
        }).catch(error => {
          console.log(error)
        });
      },
      currentChange({commit,state}:any,page:any){
        var size = state.size_page
        var start_row = (page-1) * size
        var end_row = ((page-1) * size)+size
        let member: Array<any> = [];
        if (state.inputSearch.length > 2){
          var re = new RegExp(state.inputSearch, 'gi')
          var response = _.filter(state.managersall, (item): any => {
            if (item.firstname.match(re)) {
              return true
            } else if (item.lastname != undefined && item.lastname.match(re)) {
              return true
            } else if (item.value != undefined && (item.value.match(re))) {
              return true
            } else if (item.email != undefined && item.email.match(re)) {
              return true
            } else if (item.team_name != undefined && item.team_name.match(re)) {
              return true
            }
          });
          member = response
        }else{
          member = state.managersall
        }

        if (state.sortBy == 'direct') {
          member = _.sortBy(member, [function(o:any) { return o.sub_total; }]).reverse()
        }else if (state.sortBy == 'name') {
          member = _.sortBy(member, [function(o:any) { return o.firstname; }])
        }
        // start_row = 0
        commit('setPage',page)
        commit('setManager', member.slice(start_row,end_row))
      },
      searchMembers({commit,state}:any,value:string){
        commit('setPage',1)
        let member: Array<any> = [];
        let response: Array<any> = [];
        member = state.managersall
        if (value.length > 2){
          var re = new RegExp(value, 'gi')
          response = _.filter(member, (item): any => {
            if (item.firstname.match(re)) {
              return true
            } else if (item.lastname != undefined && item.lastname.match(re)) {
              return true
            } else if (item.value != undefined && (item.value.match(re))) {
              return true
            } else if (item.email != undefined && item.email.match(re)) {
              return true
            } else if (item.team_name != undefined && item.team_name.match(re)) {
              return true
            }
          });
          if (state.sortBy == 'direct') {
            response = _.sortBy(response, [function(o:any) { return o.sub_total; }]).reverse()
          }else if (state.sortBy == 'name') {
            response = _.sortBy(response, [function(o:any) { return o.firstname; }])
          }

          commit('setResults', response.length)
          commit('setManager', response.slice(0,state.size_page))
        }else if(value.length == 0){
          if (state.sortBy == 'direct') {
            member = _.sortBy(member, [function(o:any) { return o.sub_total; }]).reverse()
          }else if (state.sortBy == 'name') {
            member = _.sortBy(member, [function(o:any) { return o.firstname; }])
          }

          commit('setResults', member.length)
          commit('setManager', member.slice(0,state.size_page))
        }
      },
      sortBy({ commit, state }: any, type: string) {
        state.sortBy = type
        let member: Array<any> = [];
        if (state.inputSearch.length > 2){
            var re = new RegExp(state.inputSearch, 'gi')
            var response = _.filter(state.managersall, (item): any => {
              if (item.firstname.match(re)) {
                return true
              } else if (item.lastname != undefined && item.lastname.match(re)) {
                return true
              } else if (item.value != undefined && (item.value.match(re))) {
                return true
              } else if (item.email != undefined && item.email.match(re)) {
                return true
              } else if (item.team_name != undefined && item.team_name.match(re)) {
                return true
              }
            });
            member = response
        }else{
          member = state.managersall
        }
        var size = state.size_page
        var page = state.page
        var start_row = (page-1) * size
        var end_row = ((page-1) * size)+size
        
        if (type == 'direct') {
          member = _.sortBy(member, [function(o:any) { return o.sub_total; }]).reverse()
        }else if (type == 'name') {
          member = _.sortBy(member, [function(o:any) { return o.firstname; }])
        }
        commit('setManager',member.slice(start_row,end_row))
      },
      async assignManagerSubmit({commit,rootState,dispatch,state}:any, objData:any){
        let member = objData.memberData
        let manager = objData.manager
        const userComp = rootState.authen.user.company
        if(member && manager){
          _.forEach(member, (item,key)=> {
            firebase.database().ref(`/users/${item.key}`).update({
              boss:manager,
              modifydatetime:format(new Date(), 'YYYY-MM-DD HH:mm')
            }).then(()=>{
              /*save logs*/
              dispatch('authen/addLogs', {
                company: userComp,
                createdate: format(new Date(), 'YYYY-MM-DD HH:mm:ss'),
                id: item.key,
                table: 'users',
                status: 'assignManager',
                user: rootState.authen.user.email
              }, {root:true})
            });
          });
          firebase.database().ref(`/genboss`).push({
            company:userComp
          }).then(function() {
            commit('setPage',1)
            dispatch('getMemberManager',rootState.authen.user)
          });
        }
      },
    },
    getters: {
        managers : (state:any) => {
            return state.managers
        },
        managersall : (state:any) => {
          return state.managersall
        },
        subManagerByKey : (state:any) => {
          return state.subManagerByKey
        },
        team : (state:any) => {
          return state.teamall
        },
        inputSearch: (state:any) => {
          return state.inputSearch
        },
        // btNext: (state:any) => {
        //   return state.btNext
        // },
        // btprevious: (state:any) => {
        //   return state.btprevious
        // },
        sizepage: (state:any) => {
          return state.size_page
        },
        results : (state:any) => {
          return state.results
        },
        page : (state:any) => {
          return state.page
        },
        membersByKey : (state:any) => {
          return state.membersByKey
        },
        bossByKey : (state:any) => {
          return state.bossByKey
        },
        teamByKey : (state:any) => {
          return state.teamByKey
        },
        loadingManagersTable : (state:any) => {
          return state.loadingManagersTable
        },
    }
  }